import { Config } from "../config/Config";
import { fetchWithAuth } from "../utils/fetchWithAuth";
import { S3StorageListResponse } from "../types/ai/api";

export class ApiDataStorage {
    static basePath = Config.json.s3Storage_URL;

    // Config.json.s3Storage_URL is missing in some deployed environments (e.g. stage). Without
    // this guard, `this.basePath` is `undefined`, `fetch(undefined)` silently resolves as a
    // relative URL against the current page route, and requests end up hitting nonsensical
    // same-origin paths like "/executions/undefined" instead of failing clearly.
    private static requireBasePath(): string {
        if (!this.basePath) {
            throw new Error('s3Storage_URL is not configured (Config.json.s3Storage_URL is missing) — cannot reach image storage.');
        }
        return this.basePath;
    }

    static ListImageProjectFileNames(folderPath:string): Promise<string[]> {
        return new Promise(async (resolve, reject) => {
            let url: string;
            try {
                url = this.requireBasePath();
            } catch (error) {
                reject(error);
                return;
            }

            let response = await fetchWithAuth(url, {
                method: 'GET',
                mode: 'cors',
                headers: { Accept: 'application/json' },
                credentials: 'include',
            });
            if (!response.ok) {
                if (response.status == 401) {
                reject('Unauthorized!');
                } else {
                reject(`Error! status: ${response.status}`);
                }
            }

            const responseObject = await (response.json()) as S3StorageListResponse;
            const filenames = responseObject.files.map(item => item.key).filter(item => item.startsWith(folderPath)).map(item => item.replace(folderPath,''));
            resolve(filenames);
        });
    };
    static ListImageProjectEntries(folderPath: string): Promise<S3StorageListResponse["files"]> {
        return new Promise(async (resolve, reject) => {
            let url: string;
            try {
                url = this.requireBasePath();
            } catch (error) {
                reject(error);
                return;
            }

            const response = await fetchWithAuth(url, {
                method: 'GET',
                mode: 'cors',
                headers: { Accept: 'application/json' },
                credentials: 'include',
            });

            if (!response.ok) {
                if (response.status === 401) {
                    reject("Unauthorized!");
                } else {
                    reject(`Error! status: ${response.status}`);
                }
                return;
            }

            const responseObject = await response.json() as S3StorageListResponse;

            resolve(
                responseObject.files.filter(item =>
                    item.key.startsWith(folderPath)
                )
            );
        });
    };

    static GetImageProject(folderPath:string, filename:string): Promise<File> {
        return new Promise(async (resolve, reject) => {
            let basePath: string;
            try {
                basePath = this.requireBasePath();
            } catch (error) {
                reject(error);
                return;
            }
            let url = `${basePath}${folderPath !== '' ? '/' : ''}${folderPath}/${filename}`

            let response = await fetchWithAuth(url, {
                method: 'GET',
                mode: 'cors',
                headers: { Accept: 'application/json' },
                credentials: 'include',
            });
            if (!response.ok) {
                if (response.status == 401) {
                reject('Unauthorized!');
                } else {
                reject(`Error! status: ${response.status}`);
                }
            };
            const responseObject = await response.blob();
            const file = new File(
                [responseObject],
                filename,
                {
                    type: response.headers.get("content-type") ?? "image/png"
                }
            );
            resolve(file);
        });
    };

    static DeleteImageProject(filePath:string): Promise<boolean> {
        return new Promise(async (resolve, reject) => {
            let basePath: string;
            try {
                basePath = this.requireBasePath();
            } catch (error) {
                reject(error);
                return;
            }
            let url = `${basePath}/${filePath}`

            let response = await fetchWithAuth(url, {
                method: 'DELETE',
                mode: 'cors',
                body: JSON.stringify(null),
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    Accept: 'application/json',
                },
                credentials: 'include',
            });
            if (!response.ok) {
                if (response.status == 401) {
                reject('Unauthorized!');
                } else {
                reject(`Error! status: ${response.status}`);
                }
            }
            resolve(true);
        });
    };

    static PostImagePropject(folderPath:string, filename:string,data:FormData): Promise<boolean> {
        return new Promise(async (resolve, reject) => {
            let basePath: string;
            try {
                basePath = this.requireBasePath();
            } catch (error) {
                reject(error);
                return;
            }
            let url = `${basePath}${folderPath !== '' ? '/' : ''}${folderPath}/${filename}`

            let response = await fetchWithAuth(url, {
                method: 'POST',
                mode: 'cors',
                body: data,
                headers: { Accept: 'application/json' },
            });
            if (!response.ok) {
                if (response.status == 401) {
                reject('Unauthorized!');
                } else {
                reject(`Error! status: ${response.status}`);
                }
            }
            resolve(true);
        });
    };

}